import {
  Box,
  Breadcrumbs,
  Card,
  CircularProgress,
  FormLabel,
  Grid,
  Input,
  Stack,
  Typography,
} from '@mui/joy';
import { AxiosError } from 'axios';
import { WarehouseResponseDTO, QueryResponse } from '@/types';
import { CreateEditWarehouseModal } from '@/components/Pages/Warehouses/CreateEditWarehouseModal';
import { createFileRoute, Link } from '@tanstack/react-router';
import { DeleteWarehouseModal } from '@/components/Pages/Warehouses/DeleteWarehouseModal';
import { useQuery } from '@tanstack/react-query';
import api from '@/services/axios';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/warehouses/$id')({
  component: WarehouseDetail,
});

function WarehouseDetail() {
  const { id } = Route.useParams();
  const { isAdmin, isSuperAdmin } = useAuth();
  const showActions = isAdmin || isSuperAdmin;

  const { data: warehouse, isLoading } = useQuery<
    QueryResponse<WarehouseResponseDTO>,
    AxiosError,
    WarehouseResponseDTO
  >({
    queryKey: ['warehouses', id],
    queryFn: () => api.get(`/warehouse/${id}`),
    select: ({ data }) => data.data,
    enabled: !!id,
  });

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!warehouse) {
    return <div>Almacén no encontrado</div>;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Stack direction='row' justifyContent='space-between'>
        <Breadcrumbs size='sm'>
          <Link to='/warehouses'>Almacenes</Link>
          <Typography>{warehouse?.name}</Typography>
        </Breadcrumbs>

        {showActions && (
          <Stack direction='row' gap={1}>
            <CreateEditWarehouseModal warehouse={warehouse} />
            <DeleteWarehouseModal
              id={warehouse?.id.toString()}
              name={warehouse?.name}
            />
          </Stack>
        )}
      </Stack>

      <Card>
        <Grid container spacing={{ xs: 1, sm: 2 }}>
          <Grid xs={12} md={6}>
            <FormLabel>Nombre</FormLabel>
            <Input
              value={warehouse?.name}
              readOnly
              variant='soft'
              size='sm'
              sx={{ backgroundColor: 'background.body' }}
            />
          </Grid>
          <Grid xs={12} md={6}>
            <FormLabel>Dirección</FormLabel>
            <Input
              value={warehouse?.address}
              readOnly
              variant='soft'
              size='sm'
              sx={{ backgroundColor: 'background.body' }}
            />
          </Grid>
        </Grid>
      </Card>
    </Box>
  );
}
